function showMoreBtnHandler(parentSelector, cardSelector, cardsQuantity) {
  const parentBlock = document.querySelector(parentSelector);

  if (!parentBlock) {
    return;
  } else {
    const showMoreBtn = parentBlock.querySelector(".btn--show-more");
    if (!showMoreBtn) {
      return;
    }
    let cardsLength = parentBlock.querySelectorAll(cardSelector).length;
    let items = cardsQuantity;
    if (cardsQuantity >= cardsLength) {
      showMoreBtn.classList.add("hidden");
    }

    showMoreBtn.addEventListener("click", () => {
      cardsLength = parentBlock.querySelectorAll(cardSelector).length;
      items += cardsQuantity;
      const cards = Array.from(parentBlock.querySelectorAll(cardSelector));
      const visibleCards = cards.slice(0, items);
      console.log(visibleCards);
      visibleCards.forEach((card) => card.classList.add("visible"));

      if (visibleCards.length >= cardsLength) {
        showMoreBtn.classList.add("hidden");
      }
    });
  }
}

export { showMoreBtnHandler };
